import moment from 'moment';

export const hasUnixDateValue = value => (
  value !== undefined &&
  value !== null &&
  value !== '' &&
  value !== '0' &&
  value !== 0 &&
  value !== 'null'
);

export const formatUnixDate = (value, format = 'YYYY-MM-DD') => (
  hasUnixDateValue(value) ? moment.unix(Number(value)).format(format) : ''
);
